module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-3.jpg?v=494e159f";